var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlterwealthLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alterwealth_-_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 416.751,
    height: 129.657,
    viewBox: "0 0 416.751 129.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2823",
    "data-name": "Group 2823",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2821",
    "data-name": "Group 2821",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3743",
    "data-name": "Path 3743",
    d: "M102.389,65.329l-2.415-7.935H83.76L81,65.329H67.2L86.52,12.2h10l19.32,53.129ZM92.039,32.21,87.21,46.354h9.315Z",
    transform: "translate(-67.2 -12.2)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3744",
    "data-name": "Path 3744",
    d: "M95.02,65.329c-8.97,0-12.42-6.21-12.42-11.73V12.2H95.02V52.564c0,1.725.69,2.415,2.415,2.415h4.14v10.35Z",
    transform: "translate(-29.471 -12.2)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    "data-name": "Path 3745",
    d: "M105.515,62.879c-8.97,0-12.42-6.21-12.42-11.73V33.9H89.3V24.585h3.795V13.2h12.42V24.585h6.21V33.9h-6.21v16.56c0,1.725.69,2.415,2.415,2.415h3.795v10.35h-6.21Z",
    transform: "translate(-13.057 -9.75)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3746",
    "data-name": "Path 3746",
    d: "M109.23,40.784c0,3.45,2.415,6.21,7.245,6.21,4.14,0,6.21-1.035,8.28-3.45L132,50.789c-4.14,4.14-8.28,6.21-15.525,6.21C107.5,57,97.5,53.894,97.5,36.3c0-13.11,7.59-20.7,17.94-20.7,11.73,0,17.94,8.625,17.94,18.975v5.52H109.23Zm11.385-11.04a5.865,5.865,0,0,0-10.35,0,5.127,5.127,0,0,0-.69,3.1h12.075A10.964,10.964,0,0,0,120.614,29.745Z",
    transform: "translate(7.033 -3.87)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M131.835,28.91a6.147,6.147,0,0,0-4.485-2.07c-1.725,0-4.83,1.035-4.83,5.52V56.509H110.1V16.145h12.075v3.45a13.972,13.972,0,0,1,9.66-3.795,12,12,0,0,1,9.315,3.795Z",
    transform: "translate(37.902 -3.38)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M172.129,65.329H161.434l-8.625-26.219-8.625,26.219H133.49L119,12.2h13.8l6.9,27.944L148.324,12.2h9.315l8.625,27.944,6.9-27.944h13.8Z",
    transform: "translate(59.706 -12.2)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M150.43,40.784c0,3.45,2.415,6.21,7.245,6.21,4.14,0,6.21-1.035,8.28-3.45l7.245,7.245c-4.14,4.14-8.28,6.21-15.525,6.21-8.97,0-18.975-3.1-18.975-20.7,0-13.11,7.59-20.7,17.94-20.7,11.73,0,17.94,8.625,17.94,18.975v5.52H150.43Zm11.385-11.04a5.865,5.865,0,0,0-10.35,0,5.127,5.127,0,0,0-.69,3.1h12.075A10.963,10.963,0,0,0,161.814,29.745Z",
    transform: "translate(107.97 -3.87)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    d: "M172.579,56.509v-3.45a11.436,11.436,0,0,1-8.97,3.795,14.28,14.28,0,0,1-9.66-3.45c-2.415-2.415-3.45-5.52-3.45-9.315,0-6.21,4.14-11.73,13.8-11.73h8.28V31.325c0-3.795-1.725-5.175-6.21-5.175a7.732,7.732,0,0,0-6.555,2.76l-7.59-7.59c4.14-4.14,7.935-5.52,14.49-5.52,11.385,0,17.595,4.83,17.595,14.49V56.509Zm-.345-16.215h-6.21c-2.415,0-3.795,1.38-3.795,3.1s1.38,3.45,4.14,3.45c2.415,0,3.45-.345,4.83-1.38,1.035-.69,1.035-2.07,1.035-4.14V40.294Z",
    transform: "translate(136.879 -3.38)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    d: "M175.22,65.329c-8.97,0-12.42-6.21-12.42-11.73V12.2h12.42V52.564c0,1.725.69,2.415,2.415,2.415h4.14v10.35Z",
    transform: "translate(167.013 -12.2)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    d: "M185.715,62.879c-8.97,0-12.42-6.21-12.42-11.73V33.9h-3.8V24.585h3.8V13.2h12.42V24.585h6.21V33.9h-6.21v16.56c0,1.725.69,2.415,2.415,2.415h3.8v10.35h-6.21Z",
    transform: "translate(183.427 -9.75)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M200.079,65.329V40.834c0-4.485-3.1-5.175-4.83-5.175s-4.83,1.035-4.83,5.175V65.329H178V12.2h12.42V28.415a13.144,13.144,0,0,1,8.97-3.795c8.625,0,12.765,6.555,12.765,14.49V65.329Z",
    transform: "translate(204.252 -12.2)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822",
    transform: "translate(195.266 70.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M126.56,34.97v6.555h9.315V43.94H126.56v7.59H123.8V32.9h13.11v2.415H126.56Z",
    transform: "translate(-123.8 -32.21)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M134.23,50.64a8.314,8.314,0,0,1-3.45-3.45,11.231,11.231,0,0,1-1.38-4.83,7.921,7.921,0,0,1,1.38-4.83,10.964,10.964,0,0,1,3.45-3.45A11.429,11.429,0,0,1,139.4,32.7a9.735,9.735,0,0,1,5.175,1.38,8.315,8.315,0,0,1,3.45,3.45,11.231,11.231,0,0,1,1.38,4.83,7.921,7.921,0,0,1-1.38,4.83,10.964,10.964,0,0,1-3.45,3.45,11.428,11.428,0,0,1-5.175,1.38A8.315,8.315,0,0,1,134.23,50.64Zm8.625-2.07a5.435,5.435,0,0,0,2.415-2.415A6.954,6.954,0,0,0,146.3,42.36a7.864,7.864,0,0,0-1.035-3.795,5.435,5.435,0,0,0-2.415-2.415,7.475,7.475,0,0,0-7.59,0,9.3,9.3,0,0,0-2.76,2.415,6.955,6.955,0,0,0-1.035,3.795,7.864,7.864,0,0,0,1.035,3.795,4.786,4.786,0,0,0,2.76,2.415A6.955,6.955,0,0,0,139.06,49.6,6.2,6.2,0,0,0,142.855,48.57Z",
    transform: "translate(-110.08 -32.7)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M139.57,49.7q-2.07-2.07-2.07-6.21V32.8h2.76V43.15c0,4.14,1.725,5.865,5.175,5.865,1.725,0,3.1-.345,3.795-1.38,1.035-1.035,1.38-2.415,1.38-4.485V32.8h2.415V43.495q0,4.14-2.07,6.21a8.116,8.116,0,0,1-5.865,2.07A7.284,7.284,0,0,1,139.57,49.7Z",
    transform: "translate(-90.236 -32.455)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M160.67,32.9V51.53H158.6l-11.04-13.8v13.8H144.8V32.9h2.07l11.04,13.8V32.9Z",
    transform: "translate(-72.352 -32.21)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M152.3,32.9h7.935a11.521,11.521,0,0,1,5.175,1.035,7.552,7.552,0,0,1,3.45,3.1,11.231,11.231,0,0,1,1.38,4.83,7.921,7.921,0,0,1-1.38,4.83,7.552,7.552,0,0,1-3.45,3.1,11.521,11.521,0,0,1-5.175,1.035H152.3Zm7.59,16.215a6.955,6.955,0,0,0,3.795-1.035,9.3,9.3,0,0,0,2.76-2.415,7.475,7.475,0,0,0,0-7.59,6.391,6.391,0,0,0-2.76-2.415,6.955,6.955,0,0,0-3.795-1.035h-5.175v13.8h5.175Z",
    transform: "translate(-53.977 -32.21)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M173.49,46.945h-10l-2.07,4.485H159l8.28-18.63h2.76l8.28,18.63h-2.76Zm-1.035-2.07-4.14-8.97-4.14,8.97Z",
    transform: "translate(-37.563 -32.455)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M171.81,35.215H165.6V32.8h15.18v2.415h-6.21V51.43h-2.76Z",
    transform: "translate(-21.393 -32.455)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M172.1,32.9h2.76V51.53H172.1Z",
    transform: "translate(-5.469 -32.21)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M180.13,50.64a8.315,8.315,0,0,1-3.45-3.45,11.23,11.23,0,0,1-1.38-4.83,7.921,7.921,0,0,1,1.38-4.83,10.966,10.966,0,0,1,3.45-3.45A11.43,11.43,0,0,1,185.3,32.7a9.736,9.736,0,0,1,5.175,1.38,8.315,8.315,0,0,1,3.45,3.45,11.231,11.231,0,0,1,1.38,4.83,7.921,7.921,0,0,1-1.38,4.83,10.965,10.965,0,0,1-3.45,3.45,11.429,11.429,0,0,1-5.175,1.38A8.315,8.315,0,0,1,180.13,50.64Zm8.625-2.07a5.435,5.435,0,0,0,2.415-2.415A6.955,6.955,0,0,0,192.2,42.36a7.864,7.864,0,0,0-1.035-3.795,5.436,5.436,0,0,0-2.415-2.415,7.475,7.475,0,0,0-7.59,0,9.3,9.3,0,0,0-2.76,2.415,6.955,6.955,0,0,0-1.035,3.795,7.864,7.864,0,0,0,1.035,3.795,4.786,4.786,0,0,0,2.76,2.415,7.475,7.475,0,0,0,7.59,0Z",
    transform: "translate(2.371 -32.7)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M199.27,32.9V51.53H197.2l-11.04-13.8v13.8H183.4V32.9h2.07l11.04,13.8V32.9Z",
    transform: "translate(22.215 -32.21)",
    fill: "#d3d3d3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2824",
    "data-name": "Group 2824",
    transform: "translate(0 66.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M66.284,17.2V31.425a8.4,8.4,0,0,1-8.323,8.323,8.3,8.3,0,0,1-8.323-8.323V17.2H32.99V31.425a8.4,8.4,0,0,1-8.323,8.323,8.3,8.3,0,0,1-8.323-8.323V17.2H0V31.425A24.862,24.862,0,0,0,41.465,49.888,24.753,24.753,0,0,0,82.779,31.425V17.2Z",
    transform: "translate(0 7.316)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M38.547,9.423h0A8.205,8.205,0,0,0,30.223,1.1,8.3,8.3,0,0,0,21.9,9.423h0V17.6H38.547Z",
    transform: "translate(11.242 -0.949)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M60.447,7.507V17.647H43.8V1H53.939A6.459,6.459,0,0,1,60.447,7.507Z",
    transform: "translate(22.484 -1)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M16.5,1V17.647H0V7.507A6.428,6.428,0,0,1,6.356,1Z",
    transform: "translate(0 -1)",
    fill: "#d3d3d3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlterwealthLogo);
export default __webpack_public_path__ + "static/media/alterwealth_-_logo.20126b2ec46a529ca7241b5d971960b1.svg";
export { ForwardRef as ReactComponent };